import React from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ButtonComponent from './button/button.component';
import { Tooltip } from '@mui/material';
import { appNote } from './constants';
import { CancelIcon } from '../../icon';

interface Props {
    Link?: string;
    AlertMessage?: string;
    Title?: string;
    OkBtnName?: string;
    Element: React.ReactElement;
    OnClickContinue?: () => void;
}

const TeamsUserAlert = (props: Props) => {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleRedirect = () => {
        if (!!props.OnClickContinue) {
            props.OnClickContinue()
        }
        else {
            window.open(props.Link, "_blank");
        }
        handleClose();
    }


    return (<>
        <div onClick={handleClickOpen} className="c-pointer">
            {props.Element}
        </div>
        <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" style={{ zIndex: 9999 }} BackdropProps={{ style: { backgroundColor: "transparent" } }}
            classes={{ paper: "br-2 dialogue-shadow" }}>
            <DialogTitle className="p-2" id="alert-dialog-title">
                <div className={`d-flex`}>
                    <span className={"h3-semibold color-display-title ml-1"}>
                        {props.Title ? props.Title : "Confirm"}</span>
                    <Tooltip title='Close' placement='bottom'>
                        <CancelIcon className={"c-pointer ml-auto mr-1"} onClick={handleClose} />
                    </Tooltip>
                </div>
            </DialogTitle>
            <DialogContent>
                <DialogContentText className="h4-regular color-menu-list-font-color" id="alert-dialog-description">
                    {!!props.AlertMessage ? props.AlertMessage : appNote.CONFIRM_REDIRECT}
                </DialogContentText>
            </DialogContent>
            <DialogActions className="pb-2 mr-1">
                <ButtonComponent ButtonLabel='Cancel' Variant='secondary-btn-small' OnClick={handleClose} />
                <ButtonComponent ButtonLabel={!!props.OkBtnName ? props.OkBtnName : "Continue"} Variant='primary-btn-small' OnClick={handleRedirect} />
            </DialogActions>
        </Dialog>
    </>
    )
}


export default TeamsUserAlert;

